import { useState } from "react";
import { useGetVaDistributorsQuery } from "../app/vaApi/vaApi";
import { buildVaMetricsQueryParams } from "../helpers/vaMetricsUtils";

export function useVaDistributors(
  initialPage = 1,
  limit = 20,
  periodFilter = { period: "this_month" }
) {
  const [page, setPage] = useState(initialPage);
  const [search, setSearch] = useState("");

  const periodParams = buildVaMetricsQueryParams(periodFilter);

  const { data, isLoading, isError, refetch } = useGetVaDistributorsQuery({
    page,
    limit,
    search,
    ...periodParams,
  });

  const items = data?.data?.items ?? [];
  const total = data?.data?.pagination?.total ?? items.length;
  const totalPages = Math.max(1, Math.ceil(total / limit) || 1);

  return {
    items,
    page,
    setPage,
    search,
    setSearch,
    total,
    totalPages,
    isLoading,
    isError,
    refetch,
  };
}
